import React from "react";
import { Row, Col, Button } from "reactstrap";

class ExceptionHandler extends React.Component {
  resetApp = () => {
    localStorage.clear();
    location.reload(true);
  };

  render() {
    const { componentStack, error } = this.props;
    return (
      <>
        <Row>
          <Col>
            <h1 className="text-center">Oops! An error occured!</h1>
          </Col>
        </Row>
        <Row>
          <Col>
            <p>Here’s what we know…</p>
            <p>
              <strong>Error:</strong> {error.toString()}
            </p>
            <p>
              <strong>Stacktrace:</strong> {componentStack}
            </p>
          </Col>
        </Row>
        <Row>
          <Col className=" d-flex justify-content-center mt-30">
            <Button onClick={this.resetApp} color="primary">
              Restart App
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}

export default ExceptionHandler;
